"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var list_1 = __importDefault(require("../../list"));
var detail_1 = __importDefault(require("../../detail"));
var add_1 = __importDefault(require("../../add"));
var reducer_1 = __importDefault(require("./reducer"));
var type_1 = require("./type");
var initialState = {
    showAdd: false,
    selectedIds: []
};
function App(props) {
    var _a, _b;
    var FormUI = props.FormUI, ViewUI = props.ViewUI, dataDef = props.dataDef, CustomListContainer = props.CustomListContainer, CustomListItem = props.CustomListItem, noDataMessages = props.noDataMessages, NoDataComponents = props.NoDataComponents;
    var _c = react_1.useReducer(reducer_1["default"], initialState), state = _c[0], dispatch = _c[1];
    var Data = props.Data;
    var width = state.showAdd || state.selectedIds.length ? 6 : 12;
    return (react_1["default"].createElement(Grid_1["default"], { container: true, spacing: 4 },
        react_1["default"].createElement(Grid_1["default"], { item: true, xs: width, sm: width, md: width, lg: width }, Data.asyncData !== undefined ? (react_1["default"].createElement(list_1["default"], { asyncData: Data.asyncData, dataDef: dataDef, showNew: function () { return dispatch({ type: type_1.ActionType.SHOW_ADD_FORM }); }, selectRow: function (id) {
                return dispatch({ type: type_1.ActionType.SELECT_ROW, payload: id });
            }, CustomListContainer: CustomListContainer, CustomListItem: CustomListItem })) : (react_1["default"].createElement(list_1["default"], { dataDef: dataDef, dataLoad: Data.list, showNew: function () { return dispatch({ type: type_1.ActionType.SHOW_ADD_FORM }); }, selectRow: function (id) {
                return dispatch({ type: type_1.ActionType.SELECT_ROW, payload: id });
            }, CustomListContainer: CustomListContainer, CustomListItem: CustomListItem, noDataMessage: noDataMessages === null || noDataMessages === void 0 ? void 0 : noDataMessages.list, NoDataComponent: NoDataComponents === null || NoDataComponents === void 0 ? void 0 : NoDataComponents.list }))),
        state.showAdd || state.selectedIds.length ? (react_1["default"].createElement(Grid_1["default"], { item: true, xs: width, sm: width, md: width, lg: width },
            react_1["default"].createElement(react_1["default"].Fragment, null,
                state.showAdd && (react_1["default"].createElement(add_1["default"], { UI: FormUI, insertPromise: Data.insert, linkBack: function () {
                        return dispatch({ type: type_1.ActionType.HIDE_ADD_FORM });
                    }, onUpdate: function (_a) {
                        var Id = _a.id;
                        return dataDef.urlPrefix;
                    }, message: (_a = dataDef.customMessages) === null || _a === void 0 ? void 0 : _a.add, PaperComponent: dataDef.PaperComponent, withPaper: (_b = dataDef.paper) === null || _b === void 0 ? void 0 : _b.add })),
                state.selectedIds &&
                    state.selectedIds.map(function (id) { return (react_1["default"].createElement(detail_1["default"], { key: "detail-" + id, config: __assign(__assign({}, dataDef), { width: { xs: 12, sm: 12, md: 12, lg: 12 } }), ViewUI: ViewUI, FormUI: FormUI, Data: Data, onBack: function () {
                            return dispatch({ type: type_1.ActionType.REMOVE_DETAIL, payload: id });
                        }, onDelete: function () {
                            return dispatch({ type: type_1.ActionType.DELETE_ITEM, payload: id });
                        }, noDataMessage: noDataMessages === null || noDataMessages === void 0 ? void 0 : noDataMessages.detail, NoDataComponent: NoDataComponents === null || NoDataComponents === void 0 ? void 0 : NoDataComponents.detail, uuid: id })); })))) : null));
}
exports["default"] = App;
